<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight] [crumbs]="['Settings', 'Checkout Settings']"  current="Global Plan Pricing"></fury-breadcrumbs>
    </fury-page-layout-header>
    <div fxLayout="column" fxLayoutAlign="start center">
      <div [@fadeInUp] class="card">
  
            <form [formGroup]="globalPricingForm" style="width: 100%;">
              <div class="content" fxLayout="column" fxLayoutGap="8px">
                <div formArrayName="updatedPrices">
                    <div *ngFor="let item of planControl.controls; let i = index">
                        <ng-container [formGroupName]="i">
                            <div class="flex-down" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                                <h3>{{item.get('pricingOption').value}}</h3>
                                <div class="flex" fxLayoutGap="10px">
                                  <mat-form-field appearance="outline" fxFlex="auto">
                                    <mat-label>Add/Subtract Display Price</mat-label>
                                    <input matInput placeholder="Add/Subtract Display Price" formControlName="displayPrice"  mask="separator.2" thousandSeparator="," [prefix]="item.get('displayPrice').value ? '$' : ''" [allowNegativeNumbers]="true"/>
                                  </mat-form-field>
                                  <mat-form-field appearance="outline" fxFlex="auto">
                                    <mat-label>Add/Subtract Discount price</mat-label>
                                    <input matInput placeholder="Add/Subtract Discount price" formControlName="discountedPrice" mask="separator.2" thousandSeparator="," [prefix]="item.get('discountedPrice').value ? '$' : ''" [allowNegativeNumbers]="true"/>
                                  </mat-form-field>
                                </div>
                                
                            </div>
                        </ng-container>
                    </div>
                </div>
              </div>
              <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
                <button mat-button type="button" class="sub-button" (click)="update()"><span>Update</span></button>
                <button mat-button type="button" class="can-button" (click)="location.back()"><span>Back</span></button>
              </div>
            </form>
      </div>
    </div>
  </fury-page-layout>